import { ApiService, toData } from '~/shared/api'
import { API_PREFIX } from '~/shared/const/request-services'
import type { ApiDataResponse } from '~/shared/types/api'
import type { LandingFeedbackDto, LandingFeedbackReceipt } from '~/models/landings'

export class LandingsFormsService extends ApiService {
  readonly urls = {
    send: (slug: string) => `${API_PREFIX}/landings/${slug}/send`,
  }

  send(slug: string, dto: LandingFeedbackDto): Promise<LandingFeedbackReceipt> {
    return this.http
      .request<ApiDataResponse<LandingFeedbackReceipt>>({
        method: 'POST',
        url: this.urls.send(slug),
        data: dto,
        silent: true,
      })
      .then(toData())
  }
}
